import React, {useContext, useEffect, useState} from "react";
import {Button, Table} from "antd";
import {DeleteOutlined, EditOutlined} from "@ant-design/icons";
import {
    AssetRuleType,
    useDeleteAssetRulesMutation, useGetAssetAttributesQuery,
    useGetAssetRulesQuery
} from "../../../../../api/assetApi";
import {ActionTypeId} from "../LogicEditor";
import { utilsEditor } from '@amaspace-editor/editor-3d'
import {ModalConfirmContext} from "../../../../../providers/ModalConfirmProvider";

type LogicRulesProps = {
    id: number
    addRule: () => void
    editRule: (rule: AssetRuleType) => void
}

const LogicRules = ({addRule, editRule, id}: LogicRulesProps) => {
    const {showModal} = useContext(ModalConfirmContext);

    const editor3D = utilsEditor()

    const [dataSource, setDataSource] = useState<AssetRuleType[]>([]);

    const {data: assetRules, isLoading, refetch: refetchAssetRules} = useGetAssetRulesQuery({id});
    const [deleteRules, result] = useDeleteAssetRulesMutation();
    const {isLoading: isLoadingDeleted, isSuccess: isSuccessDeleted} = result;

    useEffect(() => {
        if (assetRules) setDataSource(assetRules);
    }, [assetRules]);

    useEffect(() => {
        if (isSuccessDeleted) refetchAssetRules();
    }, [isSuccessDeleted]);

    const columns = [
        {
            dataIndex: 'name',
            key: 'name',
        },
        {
            dataIndex: 'actions',
            key: 'actions',
            render: (_: any, rule: AssetRuleType) => (
                <div style={{display: "flex", justifyContent: "flex-end"}}>
                    <Button type="link" onClick={() => editRule(rule)} size="small">
                        <EditOutlined/>
                    </Button>
                    <Button type="link" onClick={() => {
                        const callback = () => {
                            deleteRules([rule.id as number]);
                            if(editor3D.config.rules && rule.id) {
                                editor3D.deleteRuleConfig(rule.id)
                            }
                        };

                        showModal("delete this rule", callback);
                    }} size="small">
                        <DeleteOutlined/>
                    </Button>
                </div>
            ),
        },
    ];

    return (
        <>
            <div style={{marginBottom: 16}}>
                <Table
                    loading={isLoading || isLoadingDeleted}
                    pagination={false}
                    showHeader={false}
                    dataSource={dataSource}
                    columns={columns}
                />
            </div>

            <Button onClick={addRule}>Add Rule</Button>
        </>
    );
};

export default LogicRules;

export const actionRuleItems: { label: string, key: keyof typeof ActionTypeId, disabled: boolean }[] = [
    {
        label: "Activate Animation",
        key: "ActivateAnimation",
        disabled: false,
    },
    {
        label: "Set Visibility",
        key: "SetVisibility",
        disabled: false,
    },
    {
        label: "Set Visibility One",
        key: "SetVisibilityOne",
        disabled: false,
    },
    {
        label: "Set Material",
        key: "SetMaterial",
        disabled: false,
    },
    {
        label: "Set Active Camera",
        key: "SetActiveCamera",
        disabled: false,
    },
    {
        label: "Set Default Camera",
        key: "SetDefaultCamera",
        disabled: false,
    },
    {
        label: "Set Attribute Visible",
        key: "SetAttributeVisible",
        disabled: true,
    },
    {
        label: "Set Attribute Enabled",
        key: "SetAttributeEnabled",
        disabled: true,
    },
    {
        label: "Set Attribute Value",
        key: "SetAttributeValue",
        disabled: true,
    },
    {
        label: "Set Attribute Value Visibility",
        key: "SetAttributeValueVisibility",
        disabled: true,
    },
    {
        label: "Set Attribute Value Enabled",
        key: "SetAttributeValueEnabled",
        disabled: true,
    },
    {
        label: "Custom Script",
        key: "CustomScript",
        disabled: true,
    },
    {
        label: "Set Model",
        key: "SetModel",
        disabled: false,
    },
    {
        label: "Set Property",
        key: "SetProperty",
        disabled: true,
    },
];
